import { Base } from "../base";
import { toJSON } from "../utils";
export class NFTEventTierWhitelistConstraint {
    constructor(params) {
        var _a, _b, _c;
        this.start = Number((_a = params === null || params === void 0 ? void 0 : params.start) !== null && _a !== void 0 ? _a : 0);
        this.end = Number((_b = params === null || params === void 0 ? void 0 : params.end) !== null && _b !== void 0 ? _b : 9999999999999);
        this.max = Number((_c = params === null || params === void 0 ? void 0 : params.max) !== null && _c !== void 0 ? _c : -1);
        this.nftRequirement = Number((params === null || params === void 0 ? void 0 : params.nftRequirement) || 0);
        this.maxPerUser = Number((params === null || params === void 0 ? void 0 : params.maxPerUser) || -1);
        if (params === null || params === void 0 ? void 0 : params.externalUrl)
            this.externalUrl = params.externalUrl;
    }
    get json() {
        return toJSON(this);
    }
}
export class NFTEventWhitelist extends Base {
    constructor(params) {
        super(params);
        this.eventId = params.eventId;
        this.tierId = params.tierId;
        this.quantity = Number(params.quantity || 1);
        this.identifier = params.identifier;
        this.wallets = params.wallets || [];
        this.email = params.email || "";
        this.revoked = !!params.revoked;
        if (params.order)
            this.order = Number(params.order);
    }
}
